/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo } from "react";
import Swal from "sweetalert2";
import { MultiSelect } from "react-multi-select-component";
import { useTranslation } from "react-i18next";
import { DocCenterService } from "../services/docCenterService.js";
import { FileService } from "../services/fileService.js";
import { CmsService } from "../services/cmsService.js";
import formErrorPopupInstance from "../utils/formValidation.js";
import SweetAlertService from "../services/SweetAlertService";

const CreateDocForm = (props) => {
  const { t, i18n } = useTranslation();
  const savedLanguage = useMemo(() => i18n.language, [i18n.language]);
  const [startDate, setStartDate] = useState(
    props.documentCenterList.effectiveDateFrom.slice(0, 10)
  );
  const [endDate, setEndDate] = useState(
    props.documentCenterList.effectiveDateTo.slice(0, 10)
  );
  // eslint-disable-next-line no-unused-vars
  const [isFormValid, setIsFormValid] = useState(true); // Initialize to true
  const [check, setCheck] = useState(true); // Initialize to true
  // eslint-disable-next-line no-unused-vars
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  const [selectedVis, setSelectedVis] = useState([]);
  const [Max, setMax] = useState();
  const [IFACA, setIFACA] = useState(props.documentCenterList.ifaCaIndicator);
  const [values, setValues] = useState({
    titleEnglish: props.documentCenterList.titleEng,
    titleTraditionalChinese: props.documentCenterList.titleHk,
    titleSimplifiedChinese:
      props.documentCenterList.titleCn === null
        ? ""
        : props.documentCenterList.titleCn,
    descriptionEnglish: props.documentCenterList.descriptionEng,
    descriptionTraditionalChinese: props.documentCenterList.descriptionHk,
    descriptionSimplifiedChinese:
      props.documentCenterList.descriptionCn === null
        ? ""
        : props.documentCenterList.descriptionCn,
    effectiveDateFrom: props.documentCenterList.effectiveDateFrom.slice(0, 10),
    effectiveDateTo: props.documentCenterList.effectiveDateTo.slice(0, 10),
  });
  const [isPin, setIsPin] = useState(
    props.documentCenterList.isPin === "Y" ? true : false
  );
  const [isPromo, setIsPromo] = useState(
    props.documentCenterList.isPromo === "Y" ? true : false
  );
  const [fileId1, setFileId1] = useState(props.documentCenterList.file1Id);
  const [fileId2, setFileId2] = useState(props.documentCenterList.file2Id);
  const [fileId3, setFileId3] = useState(props.documentCenterList.file3Id);
  const [fileName1, setFileName1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [fileName3, setFileName3] = useState("");
  const [newfileName1, setNewFileName1] = useState("");
  const [newfileName2, setNewFileName2] = useState("");
  const [newfileName3, setNewFileName3] = useState("");
  const [base1, setBase1] = useState("");
  const [base2, setBase2] = useState("");
  const [base3, setBase3] = useState("");
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState(
    props.documentCenterList.mainCategoryId
  );

  const [selectedSubCategory, setSelectedSubCategory] = useState(
    props.documentCenterList.subCategoryId
  );

  const overrideStrings = {
    allItemsAreSelected: t("documentCenterPage.allItemsAreSelected"),
    clearSearch: t("documentCenterPage.clearSearch"),
    clearSelected: t("documentCenterPage.clearSelected"),
    noOptions: t("common.noRecord"),
    search: t("common.search"),
    selectAll: t("documentCenterPage.selectAll"),
    selectAllFiltered: t("documentCenterPage.selectAllFiltered"),
    selectSomeItems: t("documentCenterPage.visibility"),
  };

  useEffect(() => {
    const loadingSwal = SweetAlertService.showLoading(t("common.loading")); // Show loading spinner

    var docCenterService = new DocCenterService();
    const fileService = new FileService();

    Promise.all([
      docCenterService.retrieveVisibility(
        props.documentCenterList.documentCenterId
      ),
      fileService.download(props.documentCenterList.file1Id),
      props.documentCenterList.file2Id && props.documentCenterList.file2Id > 0 ? fileService.download(props.documentCenterList.file2Id) : null,
      props.documentCenterList.file3Id && props.documentCenterList.file3Id > 0 ? fileService.download(props.documentCenterList.file3Id) : null,
    ])
      .then((values) => {
        const visibilityData = values[0].data;
        const agentCodes = visibilityData.map((agent) => agent.agentCode);

        const brokerListPromise = docCenterService.retrieveBrokerList();

        const file1Data = values[1].data;
        const file2Data = values[2] ? values[2].data : null;
        const file3Data = values[3] ? values[3].data : null;

        return Promise.all([
          brokerListPromise,
          file1Data,
          file2Data,
          file3Data,
          agentCodes,
        ]);
      })
      .then((values) => {
        const brokerList = values[0].data;
        const file1Data = values[1];
        const file2Data = values[2];
        const file3Data = values[3];
        const agentCodes = values[4];

        const filteredBrokerCodes = brokerList.filter((broker) =>
          agentCodes.includes(broker.brokerCode)
        );

        const brokerCodesByBrokerName = {};
        if (filteredBrokerCodes.length === 0) {
          var docCenterService = new DocCenterService();
          docCenterService
            .retrieveBrokerList()
            .then((value) => {
              return value.data;
            })
            .then((data) => {
              // const formattedOptions = data.map((broker) => ({
              //   label: `${broker.brokerName} (${broker.brokerCode})`,
              //   value: broker.brokerCode,
              // }));
              // setSelected(formattedOptions);
              data.forEach((broker) => {
                const brokerName = broker.brokerName;
                const brokerCode = broker.brokerCode;

                if (brokerCodesByBrokerName[brokerName]) {
                  // Broker name already exists, add the broker code
                  brokerCodesByBrokerName[
                    brokerName
                  ].value += `, ${brokerCode}`;
                  brokerCodesByBrokerName[brokerName] = {
                    label: `${brokerName} (${brokerCodesByBrokerName[brokerName].value})`,
                    value: brokerCodesByBrokerName[brokerName].value,
                  };
                } else {
                  // New broker name, initialize the value with the broker code
                  brokerCodesByBrokerName[brokerName] = {
                    label: `${brokerName}(${brokerCode})`,
                    value: brokerCode,
                  };
                }
              });
              // Convert the object values back to an array
              const formatted = Object.values(brokerCodesByBrokerName);

              setSelected(formatted);
            });
        } else {
          // const formattedSelect = filteredBrokerCodes.map((broker) => ({
          //   label: `${broker.brokerName} (${broker.brokerCode})`,
          //   value: broker.brokerCode,
          // }));
          // setSelected(formattedSelect);
          filteredBrokerCodes.forEach((broker) => {
            const brokerName = broker.brokerName;
            const brokerCode = broker.brokerCode;

            if (brokerCodesByBrokerName[brokerName]) {
              // Broker name already exists, add the broker code
              brokerCodesByBrokerName[brokerName].value += `, ${brokerCode}`;
              brokerCodesByBrokerName[brokerName] = {
                label: `${brokerName} (${brokerCodesByBrokerName[brokerName].value})`,
                value: brokerCodesByBrokerName[brokerName].value,
              };
            } else {
              // New broker name, initialize the value with the broker code
              brokerCodesByBrokerName[brokerName] = {
                label: `${brokerName}(${brokerCode})`,
                value: brokerCode,
              };
            }
            // Convert the object values back to an array
            const formatted = Object.values(brokerCodesByBrokerName);
            setSelected(formatted);
          });
        }

        setFileName1(file1Data.documentName);
        setBase1(file1Data.documentBase64String);

        if (file2Data) {
          setFileName2(file2Data.documentName);
          setBase2(file2Data.documentBase64String);
        }

        if (file3Data) {
          setFileName3(file3Data.documentName);
          setBase3(file3Data.documentBase64String);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        SweetAlertService.close(loadingSwal); // Close loading spinner
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadFile = (number) => {
    if (number === 1) {
      download(fileName1, base1);
    }

    if (number === 2) {
      download(fileName2, base2);
    }

    if (number === 3) {
      download(fileName3, base3);
    }
  };

  useEffect(() => {
    var docCenterService = new DocCenterService();
    docCenterService
      .retrieveBrokerList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setMax(data.length);

        // Create an object to store combined broker codes by broker name
        const brokerCodesByBrokerName = {};

        // Process the data and combine broker codes
        data.forEach((broker) => {
          const brokerName = broker.brokerName;
          const brokerCode = broker.brokerCode;

          if (brokerCodesByBrokerName[brokerName]) {
            // Broker name already exists, add the broker code
            brokerCodesByBrokerName[brokerName].value += `, ${brokerCode}`;
            brokerCodesByBrokerName[brokerName] = {
              label: `${brokerName} (${brokerCodesByBrokerName[brokerName].value})`,
              value: brokerCodesByBrokerName[brokerName].value,
            };
          } else {
            // New broker name, initialize the value with the broker code
            brokerCodesByBrokerName[brokerName] = {
              label: `${brokerName}(${brokerCode})`,
              value: brokerCode,
            };
          }
        });

        // Convert the object values back to an array
        const formattedOptions = Object.values(brokerCodesByBrokerName);
        setOptions(formattedOptions);
      });
  }, []);

  const download = (name, base) => {
    const fileExtension = name.split(".").pop().toLowerCase();
    let fileType = "";
    switch (fileExtension) {
      case "csv":
        fileType = "text/csv";
        break;
      case "doc":
        fileType = "application/msword";
        break;
      case "docx":
        fileType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        break;
      case "ppt":
        fileType = "application/vnd.ms-powerpoint";
        break;
      case "pptx":
        fileType =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        break;
      case "xls":
        fileType = "application/vnd.ms-excel";
        break;
      case "xlsx":
        fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "pdf":
        fileType = "application/pdf";
        break;
      case "png":
        fileType = "image/png";
        break;
      case "jpeg":
      case "jpg":
        fileType = "image/jpeg";
        break;
      case "gif":
        fileType = "image/gif";
        break;
      default:
        fileType = "application/octet-stream";
        break;
    }

    const decodedFile = window.atob(base);
    const byteArray = new Uint8Array(decodedFile.length);
    for (let i = 0; i < decodedFile.length; ++i) {
      byteArray[i] = decodedFile.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: fileType });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSelect = (selected) => {
    setCheck(false);
    const result = selected.map((item) => item.value.split(", ")).flat(); // Use flat to flatten the array

    if (result.length === Max) {
      setSelectedVis(["ALL"]);
    } else {
      setSelectedVis(result);
    }

    setSelected(selected);
  };

  const handleIsPinChange = () => {
    if (isPin) {
      setIsPin(false);
    } else {
      setIsPin(true);
    }
  };

  const handleIsPromoChange = () => {
    if (isPromo) {
      setIsPromo(false);
    } else {
      setIsPromo(true);
    }
  };

  const handleFileInputChange = async (e, number) => {
    const loadingSwal = SweetAlertService.showLoading(t("common.loading"));

    const file = e.target.files[0];
    var fileService = new FileService();

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64String = event.target.result.split(",")[1];
        fileService
          .upload(file.name, base64String, "dc")
          .then((value) => {
            return value.data;
          })
          .then((data) => {
            if (number === 1) {
              setFileId1(data.referenceId);
              setNewFileName1(file.name);
            }
            if (number === 2) {
              setFileId2(data.referenceId);
              setNewFileName2(file.name);
            }
            if (number === 3) {
              setFileId3(data.referenceId);
              setNewFileName3(file.name);
            }
            SweetAlertService.close(loadingSwal);
          });
      };
      reader.readAsDataURL(file);
    } else {
      SweetAlertService.close(loadingSwal);
    }
  };

  const handleIFACAChange = (event) => {
    setIFACA(event.target.value);
  };

  const handleChange = (event) => {
    event.target.value.trim();
    const { name, value } = event.target;
    if (name === "effectiveDateFrom") {
      handleStartDateChange(event);
    }
    if (name === "effectiveDateTo") {
      handleEndDateChange(event);
    }
    setValues({ ...values, [name]: value });
  };

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    if (endDate && newStartDate > endDate) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
    if (startDate && newEndDate < startDate) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  };

  const goBack = () => {
    window.location.href = "/DocCenter";
    return null;
  };

  const handleSubmit = async (e) => {
    if (
      values.campaignNameZHCN === undefined ||
      values.campaignNameZHCN === null
    ) {
      values.campaignNameZHCN = "";
    }

    if (values.thumbnailDocID === undefined || values.thumbnailDocID === null) {
      values.thumbnailDocID = "";
    }

    if (values.remark === undefined || values.remark === null) {
      values.remark = "";
    }

    if (values.file === undefined || values.file === null) {
      values.file = "";
    }

    if (values.titleEnglish === "") {
      formErrorPopupInstance.addError(t("documentCenterPage.titleEng"));
    }

    if (values.titleSimplifiedChinese === "") {
      formErrorPopupInstance.addError(t("documentCenterPage.titleCn"));
    }

    if (values.titleTraditionalChinese === "") {
      formErrorPopupInstance.addError(t("documentCenterPage.titleHk"));
    }

    if (values.titleSimplifiedChinese === "") {
      formErrorPopupInstance.addError(t("documentCenterPage.titleCn"));
    }

    if (selectedMainCategory === 0) {
      formErrorPopupInstance.addError(t("cms.mainCategory"));
    }

    if (IFACA === "") {
      formErrorPopupInstance.addError(t("common.ifaCa"));
    }
    const result = selected.map((item) => item.value.split(", ")).flat(); // Use flat to flatten the array
    if (result === null || result === "" || result.length === 0) {
      formErrorPopupInstance.addError(t("documentCenterPage.visibility"));
    }

    if (fileId1 === 0 && fileId2 === 0 && fileId3 === 0) {
      formErrorPopupInstance.addError(t("documentCenterPage.missingFile"));
    }

    if (values.effectiveDateFrom === "") {
      formErrorPopupInstance.addError(t("errors.invalidDateRange"));
    }

    formErrorPopupInstance.showErrors();
    e.preventDefault();

    if (formErrorPopupInstance.errors.length === 0) {
      var docService = new DocCenterService();
      try {
        docService
          .createDocCenter(
            props.documentCenterList.documentCenterId,
            "edit",
            values,
            selectedMainCategory,
            selectedSubCategory,
            fileId1,
            fileId2,
            fileId3,
            isPin,
            isPromo,
            IFACA,
            check
              ? result.length === Max
                ? ["ALL"]
                : result
              : selectedVis.length === Max
              ? ["ALL"]
              : selectedVis
            // selectedVis.length === Max ? ["ALL"] : selectedVis
          )
          .then((value) => {
            if (value.status === 200) {
              Swal.fire({
                icon: "success",
                title: t("documentCenterPage.documentUpdated"),
                showConfirmButton: false,
                timer: 1700,
              }).then(function () {
                window.location = "/DocCenter";
              });
            }
          });
      } catch (error) {}
    }
    formErrorPopupInstance.clearErrors();
  };

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
    };
  }, []);

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveCategoryList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setMainCategories(data.firstLevelCategoryList);
      });
  }, []);

  const handleMainCategoryChange = (event) => {
    const selectedMainCategoryId = event.target.value;
    setSelectedMainCategory(selectedMainCategoryId);
    setSelectedSubCategory(0);
  };

  const handleSubCategoryChange = (event) => {
    const selectedSubCategoryId = event.target.value;
    setSelectedSubCategory(selectedSubCategoryId);
  };

  const subCategoryOptions = selectedMainCategory
    ? mainCategories.find(
        (category) =>
          String(category.categoryId) === String(selectedMainCategory)
      )?.secondLevelCategoryList
    : null;

  return (
    <>
      {isMobileScreen ? (
        <>
          <div>
            <form
              className="border border-red rounded text-mobileLandingContent"
              onSubmit={handleSubmit}>
              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label>
                    {t("documentCenterPage.visibility")}:
                    <span className="text-red-600">*</span>
                  </label>
                  <MultiSelect
                    className="text-mobileLandingContent"
                    options={options}
                    value={selected}
                    onChange={handleSelect}
                    labelledBy={"Select"}
                    isCreatable={false}
                    overrideStrings={overrideStrings}
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="titleEnglish">
                    {t("documentCenterPage.titleEng")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleEnglish"
                    name="titleEnglish"
                    value={values.titleEnglish}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="titleTraditionalChinese">
                    {t("documentCenterPage.titleHk")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleTraditionalChinese"
                    name="titleTraditionalChinese"
                    value={values.titleTraditionalChinese}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="titleSimplifiedChinese">
                    {t("documentCenterPage.titleCn")}
                  </label>
                  <span className="text-red-600">*</span>
                  <input
                    type="text"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleSimplifiedChinese"
                    name="titleSimplifiedChinese"
                    value={values.titleSimplifiedChinese}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4 hidden">
                <div className="px-2 w-full">
                  <label htmlFor="IFA/CA">
                    {t("common.ifaCa")}
                    <span className="text-red-600">*</span>
                  </label>
                  <select
                    id="IFACA"
                    aria-label="Select IFA/CA"
                    className="text-mobileLandingContent w-full bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                    value={IFACA}
                    name="ifaCaIndicator"
                    onChange={handleIFACAChange}
                    disabled>
                    <option value="IFA/CA">{t("common.ifaAndCa")}</option>
                    <option value="IFA">{t("common.ifa")}</option>
                    <option value="CA">{t("common.ca")}</option>
                  </select>
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="effectiveDateFrom">
                    {t("common.startDate")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateFrom"
                    name="effectiveDateFrom"
                    value={values.effectiveDateFrom}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="effectiveDateTo">{t("common.endDate")}</label>
                  <input
                    type="date"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateTo"
                    name="effectiveDateTo"
                    value={values.effectiveDateTo}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label>
                    {t("cms.mainCategory")}:
                    <span className="text-red-600">*</span>
                  </label>
                  <br></br>
                  <select
                    value={selectedMainCategory}
                    onChange={handleMainCategoryChange}
                    className="rounded border  border-red-400 h-10 w-full">
                    <option
                      value=""
                      className="text-ft text-mobileLandingContent">
                      {t("cms.select")}
                      {t("cms.mainCategory")}
                    </option>
                    {mainCategories.map((category) => (
                      <option
                        key={category.categoryId}
                        value={category.categoryId}>
                        {savedLanguage === "en"
                          ? category.categoryNameEng
                          : savedLanguage === "cn"
                          ? category.categoryNameCn
                          : category.categoryNameHk}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {subCategoryOptions && (
                <div className="form-row flex mx-3 my-4">
                  <div className="px-2 w-full">
                    <label>{t("cms.subCategory")}:</label>
                    <br></br>
                    <select
                      value={selectedSubCategory}
                      onChange={handleSubCategoryChange}
                      className="rounded border  border-red-300 h-10 w-full">
                      <option value="" className="text-mobileLandingContent">
                        {t("cms.select")}
                        {t("cms.subCategory")}
                      </option>
                      {subCategoryOptions.map((subCategory) => (
                        <option
                          key={subCategory.categoryId}
                          value={subCategory.categoryId}>
                          {savedLanguage === "en"
                            ? subCategory.categoryNameEng
                            : savedLanguage === "cn"
                            ? subCategory.categoryNameCn
                            : subCategory.categoryNameHk}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              <div className="form-row flex mx-3 my-3">
                <div className="px-2 w-full">
                  <label></label>
                  <br></br>
                  <a
                    href="/Categories"
                    className="no-underline bg-ft-light text-white px-2 py-3 rounded hover:bg-ft">
                    {t("documentCenterPage.createNewCate")}
                  </a>
                </div>
              </div>
              <div className="form-row flex mx-3 my-4 mt-5">
                <div className="px-2 w-full">
                  <label htmlFor="descriptionEnglish">
                    {t("documentCenterPage.descriptionEng")}
                  </label>
                  <textarea
                    type="text"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="descriptionEnglish"
                    name="descriptionEnglish"
                    value={values.descriptionEnglish}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="descriptionTraditionalChinese">
                    {t("documentCenterPage.descriptionHk")}
                  </label>
                  <textarea
                    type="text"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="descriptionTraditionalChinese"
                    name="descriptionTraditionalChinese"
                    value={values.descriptionTraditionalChinese}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 my-4">
                <div className="px-2 w-full">
                  <label htmlFor="descriptionSimplifiedChinese">
                    {t("documentCenterPage.descriptionCn")}
                  </label>
                  <textarea
                    type="text"
                    className="text-mobileLandingContent form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="descriptionSimplifiedChinese"
                    name="descriptionSimplifiedChinese"
                    value={values.descriptionSimplifiedChinese}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row flex m-3">
                <div className="px-2 w-full">
                  <p className="text-landingHeader font-bold">
                    {t("common.file")} (1)
                  </p>
                  <p className="text-mobileLandingContent">
                    {t("common.currentFile")}:{" "}
                    {fileId1 !== 0 ? (
                      <a
                        className="no-underline cursor-pointer	 text-ft-light hover:text-ft"
                        onClick={() => downloadFile(1)}>
                        {" "}
                        {fileName1}
                      </a>
                    ) : (
                      "No uploaded file"
                    )}
                  </p>
                  <label htmlFor="file-upload1" className="upload-label mr-3 ">
                    {fileId1
                      ? t("common.browseReplace")
                      : t("common.browseUpload")}
                  </label>
                  <input
                    id="file-upload1"
                    type="file"
                    accept="image/*,.pdf,.xlsx, .xls, .csv, .ppt, .pptx, .doc, .docx"
                    onChange={(e) => handleFileInputChange(e, 1)}
                  />
                </div>
              </div>

              <div className="form-row flex m-3">
                <div className="px-2 w-full">
                  <p className="text-landingHeader font-bold">
                    {t("common.file")} (2)
                  </p>
                  <p className="text-mobileLandingContent">
                    {t("common.currentFile")}:{" "}
                    <a
                      className="no-underline cursor-pointer	 text-ft-light hover:text-ft"
                      onClick={() => downloadFile(2)}>
                      {" "}
                      {fileName2}
                    </a>
                  </p>
                  <label htmlFor="file-upload2" className="upload-label mr-3">
                    {fileId2
                      ? t("common.browseReplace")
                      : t("common.browseUpload")}
                  </label>
                  <input
                    id="file-upload2"
                    type="file"
                    accept="image/*,.pdf,.xlsx, .xls, .csv, .ppt, .pptx, .doc, .docx"
                    onChange={(e) => handleFileInputChange(e, 2)}
                  />
                </div>
              </div>

              <div className="form-row flex m-3">
                <div className="px-2 w-full">
                  <p className="text-landingHeader font-bold">
                    {t("common.file")} (3)
                  </p>
                  <p className="text-mobileLandingContent">
                    {t("common.currentFile")}:{" "}
                    <a
                      className="no-underline cursor-pointer	 text-ft-light hover:text-ft"
                      onClick={() => downloadFile(3)}>
                      {" "}
                      {fileName3}{" "}
                    </a>
                  </p>
                  <label htmlFor="file-upload3" className="upload-label mr-3">
                    {fileId3
                      ? t("common.browseReplace")
                      : t("common.browseUpload")}
                  </label>
                  <input
                    id="file-upload3"
                    type="file"
                    accept="image/*,.pdf,.xlsx, .xls, .csv, .ppt, .pptx, .doc, .docx"
                    onChange={(e) => handleFileInputChange(e, 3)}
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 mt-5">
                <div className="px-2 w-full">
                  <label className="relative inline-flex items-center mr-5 cursor-pointer">
                    <input
                      type="checkbox"
                      onChange={handleIsPinChange}
                      value={isPin}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-ft-light"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                      {t("documentCenterPage.pin")}
                    </span>
                  </label>
                </div>
              </div>

              <div className="form-row flex mx-3 mt-4">
                <div className="px-2 w-full">
                  <label className="relative inline-flex items-center mr-5 cursor-pointer">
                    <input
                      type="checkbox"
                      onChange={handleIsPromoChange}
                      value={isPromo}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-ft-light"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                      {t("documentCenterPage.sendToLatestPromos")}
                    </span>
                  </label>
                </div>
              </div>

              <div className="px-6 py-4 flex justify-end">
                <button
                  type="Submit"
                  className=" text-white bg-ft-light hover:bg-ft rounded-md px-4 py-2 active:bg-white active:text-ft active:ring-1 active:ring-ft transition">
                  {t("common.save")}
                </button>
                <button
                  onClick={goBack}
                  type="button"
                  className="ml-4 text-ft-light ring-1 ring-ft-light bg-white hover:bg-ft hover:text-white rounded-md px-4 py-2 active:bg-white active:text-red-500 active:ring-1 active:ring-red-500 transition">
                  {t("common.cancel")}
                </button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <div>
          <form
            className="border border-red rounded p-1 text-content"
            onSubmit={handleSubmit}>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <div className="">
                  <label>
                    {t("documentCenterPage.visibility")}:
                    <span className="text-red-600">*</span>
                  </label>
                  <MultiSelect
                    options={options}
                    value={selected}
                    onChange={handleSelect}
                    labelledBy={"Select visibility"}
                    isCreatable={false}
                    overrideStrings={overrideStrings}
                  />
                </div>
              </div>
            </div>

            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="titleEnglish">
                    {t("documentCenterPage.titleEng")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleEnglish"
                    name="titleEnglish"
                    value={values.titleEnglish}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="titleTraditionalChinese">
                    {t("documentCenterPage.titleHk")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleTraditionalChinese"
                    name="titleTraditionalChinese"
                    value={values.titleTraditionalChinese}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="titleSimplifiedChinese">
                    {t("documentCenterPage.titleCn")}
                  </label>
                  <span className="text-red-600">*</span>
                  <input
                    type="text"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleSimplifiedChinese"
                    name="titleSimplifiedChinese"
                    value={values.titleSimplifiedChinese}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12 hidden">
                  <label htmlFor="IFA/CA">
                    {t("common.ifaCa")}
                    <span className="text-red-600">*</span>
                  </label>
                  <select
                    id="IFACA"
                    aria-label="Select IFA/CA"
                    className="w-full bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                    value={IFACA}
                    name="ifaCaIndicator"
                    onChange={handleIFACAChange}
                    disabled>
                    <option value="IFA/CA">{t("common.ifaAndCa")}</option>
                    <option value="IFA">{t("common.ifa")}</option>
                    <option value="CA">{t("common.ca")}</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="effectiveDateFrom">
                    {t("common.startDate")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateFrom"
                    name="effectiveDateFrom"
                    value={values.effectiveDateFrom}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="effectiveDateTo">{t("common.endDate")}</label>
                  <input
                    type="date"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateTo"
                    name="effectiveDateTo"
                    value={values.effectiveDateTo}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-full ml-6 flex ">
                <div className="mt-2 w-2/5 mr-4">
                  <label>
                    {t("cms.mainCategory")}:
                    <span className="text-red-600">*</span>
                  </label>
                  <br></br>
                  <select
                    value={selectedMainCategory}
                    onChange={handleMainCategoryChange}
                    className="rounded border  border-red-400 h-10 w-full">
                    <option value="" className="text-ft">
                      {t("cms.select")}
                      {t("cms.mainCategory")}
                    </option>
                    {mainCategories.map((category) => (
                      <option
                        key={category.categoryId}
                        value={category.categoryId}>
                        {savedLanguage === "en"
                          ? category.categoryNameEng
                          : savedLanguage === "cn"
                          ? category.categoryNameCn
                          : category.categoryNameHk}
                      </option>
                    ))}
                  </select>
                </div>

                {subCategoryOptions && (
                  <div className="mt-2 w-2/5 mr-4">
                    <label>{t("cms.subCategory")}:</label>
                    <br></br>
                    <select
                      value={selectedSubCategory}
                      onChange={handleSubCategoryChange}
                      className="rounded border  border-red-300 h-10 w-full">
                      <option value="">
                        {t("cms.select")}
                        {t("cms.subCategory")}
                      </option>
                      {subCategoryOptions.map((subCategory) => (
                        <option
                          key={subCategory.categoryId}
                          value={subCategory.categoryId}>
                          {subCategory.categoryNameEng}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="mt-2 w-1/5">
                  <label></label>
                  <br></br>
                  <a
                    href="/Categories"
                    className="no-underline bg-ft-light text-white px-4 py-4 rounded hover:bg-ft">
                    {t("documentCenterPage.createNewCate")}
                  </a>
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <label htmlFor="descriptionEnglish">
                  {t("documentCenterPage.descriptionEng")}
                </label>
                <textarea
                  type="text"
                  className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                  id="descriptionEnglish"
                  name="descriptionEnglish"
                  value={values.descriptionEnglish}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <label htmlFor="descriptionTraditionalChinese">
                  {t("documentCenterPage.descriptionHk")}
                </label>
                <textarea
                  type="text"
                  className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                  id="descriptionTraditionalChinese"
                  name="descriptionTraditionalChinese"
                  value={values.descriptionTraditionalChinese}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <label htmlFor="descriptionSimplifiedChinese">
                  {t("documentCenterPage.descriptionCn")}
                </label>
                <textarea
                  type="text"
                  className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                  id="descriptionSimplifiedChinese"
                  name="descriptionSimplifiedChinese"
                  value={values.descriptionSimplifiedChinese}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-row flex m-3">
              <div className="px-4 w-full">
                <p className="text-landingHeader font-bold">
                  {t("common.file")} (1)
                </p>
                <p className="text-content">
                  {t("common.currentFile")}:{" "}
                  {fileId1 !== 0 ? (
                    <a
                      className="no-underline cursor-pointer	 text-ft-light hover:text-ft"
                      onClick={() => downloadFile(1)}>
                      {fileName1}
                    </a>
                  ) : (
                    "No uploaded file"
                  )}
                </p>
                <label htmlFor="file-upload1" className="upload-label mr-3 ">
                  {fileId1
                    ? t("common.browseReplace")
                    : t("common.browseUpload")}
                </label>
                <input
                  id="file-upload1"
                  type="file"
                  accept="image/*,.pdf,.xlsx, .xls, .csv, .ppt, .pptx, .doc, .docx"
                  onChange={(e) => handleFileInputChange(e, 1)}
                  className="hidden"
                />
                <label
                  htmlFor="file-upload1"
                  className="py-2 mr-3 rounded-md bg-ft-light text-white px-4  hover:bg-ft cursor-pointer">
                  {t("common.selectFile")}
                </label>
                <label htmlFor="file-upload" className="upload-label mr-3 ">
                  {newfileName1 ? newfileName1 : t("common.noFile")}
                </label>
              </div>
            </div>
            <div className="form-row flex m-3">
              <div className="px-4 w-full">
                <p className="text-landingHeader font-bold">
                  {t("common.file")} (2)
                </p>
                <p className="text-content">
                  {t("common.currentFile")}:{" "}
                  <a
                    className="no-underline cursor-pointer	 text-ft-light hover:text-ft"
                    onClick={() => downloadFile(2)}>
                    {" "}
                    {fileName2}
                  </a>
                </p>
                <label htmlFor="file-upload2" className="upload-label mr-3">
                  {fileId2
                    ? t("common.browseReplace")
                    : t("common.browseUpload")}
                </label>
                <input
                  id="file-upload2"
                  type="file"
                  accept="image/*,.pdf,.xlsx, .xls, .csv, .ppt, .pptx, .doc, .docx"
                  onChange={(e) => handleFileInputChange(e, 2)}
                  className="hidden"
                />
                <label
                  htmlFor="file-upload2"
                  className="py-2 mr-3 rounded-md bg-ft-light text-white px-4  hover:bg-ft cursor-pointer">
                  {t("common.selectFile")}
                </label>
                <label htmlFor="file-upload" className="upload-label mr-3 ">
                  {newfileName2 ? newfileName2 : t("common.noFile")}
                </label>
              </div>
            </div>
            <div className="form-row flex m-3">
              <div className="px-4 w-full">
                <p className="text-landingHeader font-bold">
                  {t("common.file")} (3)
                </p>
                <p className="text-content">
                  {t("common.currentFile")}:{" "}
                  <a
                    className="no-underline cursor-pointer	 text-ft-light hover:text-ft"
                    onClick={() => downloadFile(3)}>
                    {" "}
                    {fileName3}{" "}
                  </a>
                </p>
                <label htmlFor="file-upload3" className="upload-label mr-3">
                  {fileId3
                    ? t("common.browseReplace")
                    : t("common.browseUpload")}
                </label>
                <input
                  id="file-upload3"
                  type="file"
                  accept="image/*,.pdf,.xlsx, .xls, .csv, .ppt, .pptx, .doc, .docx"
                  onChange={(e) => handleFileInputChange(e, 3)}
                  className="hidden"
                />
                <label
                  htmlFor="file-upload3"
                  className="py-2 mr-3 rounded-md bg-ft-light text-white px-4  hover:bg-ft cursor-pointer">
                  {t("common.selectFile")}
                </label>
                <label htmlFor="file-upload" className="upload-label mr-3 ">
                  {newfileName3 ? newfileName3 : t("common.noFile")}
                </label>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label className="relative inline-flex items-center mr-5 cursor-pointer">
                    <input
                      type="checkbox"
                      defaultChecked={isPin}
                      onChange={handleIsPinChange}
                      value={isPin}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-ft-light"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900 ">
                      {t("documentCenterPage.pin")}
                    </span>
                  </label>
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label className="relative inline-flex items-center mr-5 cursor-pointer">
                    <input
                      type="checkbox"
                      defaultChecked={isPromo}
                      onChange={handleIsPromoChange}
                      value={isPromo}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-ft-light"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900">
                      {t("documentCenterPage.sendToLatestPromos")}
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div className="px-6 py-4 flex justify-end">
              <button
                type="Submit"
                className=" text-white bg-ft-light hover:bg-ft rounded-md px-4 py-2 active:bg-white active:text-ft active:ring-1 active:ring-ft transition">
                {t("common.save")}
              </button>
              <button
                onClick={goBack}
                type="button"
                className="ml-4 text-ft-light ring-1 ring-ft-light bg-white hover:bg-ft hover:text-white rounded-md px-4 py-2 active:bg-white active:text-red-500 active:ring-1 active:ring-red-500 transition">
                {t("common.cancel")}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default CreateDocForm;
